import { formattedDatePp } from "../utils/common_lib";

export const AppListing = ({ listData, cols, actions, loading }) => {
  const getColData = (item, col,itemIndex) => {
    if (typeof col.getData === "function") {
      return col.getData(item,itemIndex);
    }
    if(col.type === 'date'){
      return formattedDatePp(item[col.key], col.format || null);
    }
    if (col.type === "amount") {
      return `$${item[col.key] || "0"}`;
    }
    return item[col.key] || "";
  };

  return (
    <>
      <div className="flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-4 lg:-mx-6">
          <div className="inline-block min-w-full py-2 align-middle sm:px-4 lg:px-6">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300 custom-table">
                <thead className="bg-gray-50">
                  <tr>
                    {cols.map((col, colIndex) => (
                      <th
                        key={`col_title_${colIndex}`}
                        scope="col"
                        className="py-3.5 px-3 text-left text-sm text-slate-500"
                      >
                        {col.skipColTitle ? "" : col.title}
                      </th>
                    ))}
                    {actions ? <div className="flex-none"></div> : ""}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {loading ? (
                    <tr>
                      <td
                        colSpan={cols.length + 1}
                        className="text-center py-2"
                      >
                        Loading...
                      </td>
                    </tr>
                  ) : (
                    <>
                      {listData?.map((item, itemIndex) => (
                        <tr key={item?.id || itemIndex}>
                          {cols?.map((col, colIndex) => (
                            <td key={colIndex} className=" py-4 px-3 text-sm font-medium text-gray-900 ">
                              <div
                                title={col.title}
                                onClick={() => {
                                  if (typeof col.onClick === "function") {
                                    col.onClick(item, col);
                                  }
                                }}
                                className={`${
                                  col.onClick
                                    ? "cursor-pointer text-primary"
                                    : ""
                                } 
                                        ${col?.colClass && col?.colClass}`}
                              >
                                {getColData(item, col, itemIndex)}
                              </div>
                            </td>
                          ))}
                          {actions ? (
                            <td className="flex-none">
                              <span>
                                <button className="list-action-button">
                                  <i className="fa fa-ellipsis-v fa-lg"></i>
                                </button>
                              </span>
                            </td>
                          ) : (
                            ""
                          )}
                        </tr>
                      ))}
                    </>
                  )}
                  {listData?.length === 0 && !loading && (
                    <div className="p-2">No record found.</div>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
